import { Injectable, inject } from '@angular/core';
import { GoogleTrackingService } from '../google-tracking.service';

@Injectable({
    providedIn: 'root',
})
export class ConsultationsTrackingService {
    private readonly _googleTrackingService = inject(GoogleTrackingService);

    public trackConsultationGoogleRatingClick(): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Zur Google Bewertung',
        });
    }

    public trackConsultationDealerSearchTileClick(consultationId: string): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Fachhändlersuche',
            consultationId,
        });
    }

    public trackConsultationShopTileClick(consultationId: string): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Muster bestellen',
            consultationId,
        });
    }

    public trackConsultationConfiguratorTileClick(consultationId: string): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Zum Konfigurator',
            consultationId,
        });
    }
}
